import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "ant-row",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16" }, null, -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_5 = {
  class: "ant-btn-group ss-tamanho-completo",
  style: {"justify-content":"flex-end"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Excluir todos os itens", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "ant-btn ant-btn-block ant-btn-primary ss-btn-acao-destaque ss-fonte-12-mobile"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Adicionar produtos")
], -1)
const _hoisted_9 = { class: "ant-table-column-title" }
const _hoisted_10 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_11 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-up",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "caret-down",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_25 = { class: "ant-input-affix-wrapper ss-paginacao-qtde-registros" }
const _hoisted_26 = { class: "ant-input-suffix" }
const _hoisted_27 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_buscar_produtos_modal = _resolveComponent("buscar-produtos-modal")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_alteracao_preco_produto_modal = _resolveComponent("alteracao-preco-produto-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_ctx.props.tiposPrecos.length <= 0 || _ctx.props.estruturas.length <= 0)
    ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
        key: 0,
        mensagem: "É necessário definir os tipos de preços"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"]),
        _createVNode(_component_buscar_produtos_modal, {
          titulo: "Adicionar itens na tabela de preço",
          empresas: _ctx.props.empresas,
          visivel: _ctx.state.exibirBuscaProduto,
          "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirBuscaProduto) = $event)),
          parametrosConsultaDefinicao: _ctx.defineParametrosConsultaNovosProdutos(),
          onConfirmadoSelecaoProdutos: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarNovosProdutos($event)))
        }, null, 8, ["empresas", "visivel", "parametrosConsultaDefinicao"]),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-block ss-btn-acao-destaque ss-fonte-12-mobile",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmaExclusaoProdutos(true)))
              }, _hoisted_7),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, {
                        key: "1",
                        onClick: _ctx.apresentarSelecaoNovosProdutos
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Selecionar produtos específicos")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_menu_item, {
                        key: "2",
                        onClick: _ctx.adicionarTodosProdutosAusentesNaTabela
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Todos que não estão na tabela")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_a_collapse, {
          activeKey: _ctx.state.painelFiltroAtivo,
          "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.painelFiltroAtivo) = $event)),
          ghost: "",
          class: "ss-collapse-filtro"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "PESQUISAR ITEM NA TABELA DE PREÇO"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_busca_avancada, {
                  buscaAvancada: _ctx.gradeBase.buscaAvancada,
                  "onUpdate:buscaAvancada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
                  textoBotaoAplicarFiltros: "Pesquisar",
                  visivel: true,
                  marginPadrao: false,
                  empresas: _ctx.props.empresas,
                  onAplicarFiltros: _ctx.aplicarFiltros
                }, null, 8, ["buscaAvancada", "empresas", "onAplicarFiltros"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"]),
        _createElementVNode("div", null, [
          _createTextVNode(" ITENS EXISTENTES "),
          _createVNode(_component_a_table, {
            columns: _ctx.gradeBase.colunas.filter(item => item.visible),
            "data-source": _ctx.state.produtos,
            rowKey: "codigoDefinicao",
            pagination: false,
            loading: _ctx.gradeBase.buscandoDados,
            scroll: { x: _ctx.gradeBase.windowWidth , y: 400},
            "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.preencheCodigosSelecionados },
            size: "small"
          }, {
            headerCell: _withCtx(({ column }) => [
              (column.ordering)
                ? (_openBlock(), _createElementBlock("div", {
                    key: column.key,
                    class: "ss-coluna-ordenada"
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(column.title), 1),
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(), _createElementBlock("a", {
                          title: "Ordenação crescente",
                          key: 'ord-asc' + column.key,
                          class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                          onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                        }, _hoisted_14, 10, _hoisted_12)),
                        (_openBlock(), _createElementBlock("a", {
                          title: "Ordenação decrescente",
                          key: 'ord-desc' + column.key,
                          class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                          onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                        }, _hoisted_17, 10, _hoisted_15))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("a", {
                      class: "visualizar",
                      onClick: ($event: any) => (_ctx.iniciarAlteracaoPreco(record))
                    }, [
                      _createVNode(_component_icone, { nome: "editar" })
                    ], 8, _hoisted_19),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.confirmaExclusaoProduto(record)),
                      class: "excluir"
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_20)
                  ]))
                : (column.key.includes(_ctx.chaveTipoPrecoValor))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.obtemPrecoItemTabela(record.codigoDefinicao,column.key)), 1)
                    ], 64))
                  : (column.key.includes(_ctx.chaveTipoPrecoMarkup))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.obtemMarkupItemTabela(record.codigoDefinicao,column.key)), 1)
                      ], 64))
                    : (column.key.includes(_ctx.chaveTipoPrecoDesconto))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.obtemDescontoItemTabela(record.codigoDefinicao,column.key)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
            ]),
            emptyText: _withCtx(() => [
              _createVNode(_component_mensagem_sem_dados, {
                resultadoPesquisa: !_ctx.gradeBase.buscandoDados,
                mensagem: _ctx.gradeBase.buscandoDados?'Buscando informações, por favor aguarde...':'Nenhum produto foi localizado nesta tabela com os filtros informados!'
              }, null, 8, ["resultadoPesquisa", "mensagem"])
            ]),
            _: 1
          }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-block ant-btn-primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmaExclusaoProdutos(false)))
              }, " Excluir itens selecionados ", 512), [
                [_vShow, _ctx.gradeBase.codigosSelecionados.length > 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_a_pagination, {
                class: "ss-paginacao-completa",
                current: _ctx.gradeBase.paginacao.current,
                "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gradeBase.paginacao.current) = $event)),
                size: "small",
                total: _ctx.gradeBase.paginacaoApi.totalRegistros,
                "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} produtos`,
                "page-size": _ctx.gradeBase.paginacao.pageSize,
                pageSizeOptions: _ctx.gradeBase.paginacao.pageSizeOptions,
                onShowSizeChange: _ctx.mudarQuantidadeRegistrosPorPagina,
                onChange: _ctx.mudarPagina
              }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.gradeBase.totalRegistrosComMascara) = $event)),
                  onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal($event))),
                  placeholder: "Total registros",
                  type: "text",
                  class: "ant-input hidden"
                }, null, 544), [
                  [_vModelText, _ctx.gradeBase.totalRegistrosComMascara],
                  [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                ]),
                _createElementVNode("span", _hoisted_26, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Limite total de produtos. Lembre-se: Quanto menor a quantidade de produtos mais rápido o seu resultado será apresentado."
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_27, [
                        _createVNode(_component_icone, { nome: "informacoes" })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createVNode(_component_alteracao_preco_produto_modal, {
            ref: "refAlterarPreco",
            codigoTabelaPreco: _ctx.props.codigoTabelaPreco,
            empresas: _ctx.props.empresas,
            estruturas: _ctx.props.estruturas,
            tiposPrecos: _ctx.props.tiposPrecos,
            onPrecosAtualizados: _ctx.precosAtualizados
          }, null, 8, ["codigoTabelaPreco", "empresas", "estruturas", "tiposPrecos", "onPrecosAtualizados"])
        ])
      ]))
}